import { render, staticRenderFns } from "./admin-delay.vue?vue&type=template&id=936252b0"
import script from "./admin-delay.vue?vue&type=script&lang=js"
export * from "./admin-delay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports